import { cookieOptionDecider } from './cookies';

// Constants covering the two options for A/B testing
// TODO: Remove [BENTO-15208] after A/B main art autoplay test goes away.
export const AUTOPLAY_TEST_GROUPS = {
  AUTOPLAY_MAIN_ART: 'AUTOPLAY_MAIN_ART',
  NO_AUTOPLAY_MAIN_ART: 'NO_AUTOPLAY_MAIN_ART',
};

export function getAutoplayMainArtTestGroup({
  AUTOPLAY_MAIN_ART_PERCENTAGE,
  NO_AUTOPLAY_MAIN_ART_PERCENTAGE,
}) {
  const groups = [
    [AUTOPLAY_TEST_GROUPS.AUTOPLAY_MAIN_ART, AUTOPLAY_MAIN_ART_PERCENTAGE],
    [AUTOPLAY_TEST_GROUPS.NO_AUTOPLAY_MAIN_ART, NO_AUTOPLAY_MAIN_ART_PERCENTAGE],
  ];

  return cookieOptionDecider(groups);
}
